export const DATE_TIME_FORMAT = 'dd.MM.yyyy HH:mm';
export const DATE_FORMAT = 'dd.MM.yyyy';
export const YEAR_FORMAT = 'yyyy';
export const TIME_FORMAT = 'HH:mm';

export const FIELD_CSS_NAME = 'd44d4__fieldWrapper';
